export default "__VITE_ASSET__DvoJ4BDE__"